import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import _ from 'lodash';
import * as userApi from '../../../../lib/api/user';

/**
 * 직원 선택 Autocomplete 컴포넌트
 * - formik의 name 필드에 UUID 설정
 * - nameField가 지정되면 해당 필드에 이름 설정
 */
const EmpSelectbox = ({ formik, name, nameField, label, variant, margin, disabled = false }) => {
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    async function fetchMyAPI() {
      let response = await userApi.getUsers();
      setOptions(response.data.list);
    }
    fetchMyAPI();
  }, []);

  useEffect(() => {
    const uuid = formik.values[name];
    if (!uuid) {
      // 값이 없으면 선택 해제
      setSelectedEmp(null);
      return;
    }
    if (options.length > 0) {
      const selected = _.find(options, (item) => item.usrUuid === uuid);
      setSelectedEmp(selected || null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, formik.values[name]]);

  return (
    <Autocomplete
      disablePortal
      disabled={disabled}
      id={name}
      options={options || []}
      getOptionLabel={(option) => option.usrNm + ' ' + option.gradeNm}
      value={selectedEmp}
      onChange={(_event, newEmp) => {
        setSelectedEmp(newEmp);
        formik.setFieldValue(name, newEmp?.usrUuid ?? '');
        if (nameField) {
          formik.setFieldValue(nameField, newEmp?.usrNm || '');
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          margin={margin}
          variant={variant}
          label={label}
          error={formik.touched[name] && Boolean(formik.errors[name])}
          helperText={formik.touched[name] && formik.errors[name]}
        />
      )}
    />
  );
};

export default EmpSelectbox;
